(function() {
    'use strict';

    angular
        .module('app')
        .controller('scheduleController', scheduleController);

    function scheduleController($scope, scheduleService, $timeout, $rootScope, viewModel) {
        var vm = this;
        vm.changeDate = changeDate;
        vm.outputFile = outputFile;
        vm.changeArea = changeArea;
        vm.getStartForList = getStartForList;
        vm.getEndForList = getEndForList;
        vm.getAllDay = getAllDay;
        vm.showButton = showButton;
        vm.trigger = 1;

        vm.view = {
            isLogin: sessionStorage.getItem('token')
        };

        init();

        function init() {
            vm.calendarAreas = viewModel.data;
            vm.schedule = moment().add(8, 'hour');
            getSchedule();
        }

        function changeDate() {
            $timeout(function() {
                getSchedule();
            }, 10);
        }

        function getSchedule() {
            vm.clickDay = vm.schedule.format('YYYY/MM/DD');
            var calendarSerilNo = vm.calendarArea ? vm.calendarArea.calendarAreaSerilNo : 0;
            vm.promise = scheduleService.get(vm.schedule, calendarSerilNo).then(function(data) {
                vm.dateItem = data.data.scheduleTodays;
                vm.trigger++;
                return data;
            });
        }

        function outputFile(item) {
            if (DEVICE_TYPE !== null && DEVICE_TYPE.toLowerCase() === 'android') {
                var param = {
                    title: item.title,
                    description: item.txtContent,
                    isAllDay: item.isAllDay,
                    begin: (Date.parse(item.startDate) - (8 * 60 * 60 * 1000)) / 1000,
                    end: (Date.parse(item.endDate) - (8 * 60 * 60 * 1000)) / 1000,
                    reminder: 0,
                    isEveryDay: item.isEveryDay
                };
                var method = "appendEvent";
                appCallback(method, param);
            } else {
                // 瀏覽器或其他
                var isIos = true;
                if (DEVICE_TYPE !== null && DEVICE_TYPE.toLowerCase() === 'ios') {
                    isIos = true;
                }
                location.href = scheduleService.donwloadIcs(item, isIos);
                toastr.success($rootScope.translate.tshrExportScheduleMessage);
            }
        }

        function changeArea() {           
            getSchedule();
        }

        function getStartForList(item) {
            if (item.isAllDay) {
                return moment(item.startDate).format('YYYY/MM/DD');
            }
            return moment(item.startDate).format('YYYY/MM/DD HH:mm');
        }

        function getEndForList(item) {
            if (item.isEveryDay) {
                return $rootScope.translate.any;
            }

            if (item.isAllDay) {
                return moment(item.endDate).subtract(1, 'd').format('YYYY/MM/DD');
            }
            return moment(item.endDate).format('YYYY/MM/DD HH:mm');
        }

        function getAllDay(item) {
            if (item.isAllDay) {
                return $rootScope.translate.allDay;
            }
        }

        function showButton(item) {
            var show = true;
            var now = moment();
            var eventDte = moment(item.endDate); //以事件結束日期比較，事件已結束的就不顯示提醒我

            if (now > eventDte) {
                show = false;
            }
            //console.log('show:',show);
            return show;
        }
    }
})();